import React, { useEffect } from 'react';
import { useState } from '@hookstate/core';
import { useHistory, generatePath } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import {
    Box,
    // Button,
    Avatar,
    Typography,
    CircularProgress,
    Tooltip,
    IconButton,
    Divider,
    Button,
    InputLabel,
    Paper,
} from '@mui/material';
import RouteConstants from '../../constants/routeConstants';
import Title from '../../sharedcomponents/title/title';
// import CircleIcon from '@mui/icons-material/Circle';
import { createTheme } from '@mui/material/styles';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';

// import AppBarHeader from '../../sharedcomponents/appbarHeader/appbarHeader';
import { setTheme, useThemeState } from '../../hookState/ThemeState';
import {
    setAgentVisible,
    useAgentState,
    handleAgentEventClose,
} from '../../hookState/AgentState';
import { updateModuleState } from '../../stores/eventStore';
// import IOSOnOffSwitch from '../../sharedcomponents/switchComponent/IOSOnOffSwitch';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import NotificationSetting from './notificationSetting';

import DefaultEvent from '../../assets/images/default_event.jpg';
import Weather from '../../sharedcomponents/Weather';
import Logo from '../../assets/images/logo.png';
import { getDetails } from '../../stores/authStore';

import ProfileSections from './profileSections';

const theme = createTheme();
const useStyles = makeStyles({
    list_item_text: {
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
    },
    block_text: {
        margin: 8,
        fontSize: '0.85rem',
        fontWeight: 400,
        color: 'black',
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(1),
        backgroundColor: '#fff',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        // padding: theme.spacing(0.5),
        alignItems: 'center',
        minWidth: '100%',
        width: 'max-content',
    },
    paperHeaderContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(1),
        backgroundColor: '#fff',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        // padding: theme.spacing(1),
        // padding: theme.spacing(0.5),
        alignItems: 'center',
        minWidth: '100%',
        maxWidth: '100%',
        width: 'max-content',
    },
});

export const participantStatus = [
    { id: 0, name: '#C8102E' },
    { id: 1, name: '#BC8D15' },
    { id: 2, name: '#148845' },
    { id: 3, name: '#C8102E' },
];
export const getStatus = (statusID) => {
    const status = participantStatus.find((item) => item.id === statusID)?.name;
    if (status) {
        return status;
    } else {
        return '';
    }
};

const AgentProfile = () => {
    const userInfo = Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const history = useHistory();
    const agentState = useAgentState();
    const openDialog = useState(false);

    const [agentData, setAgentData] = React.useState({});
    const [participantData, setParticipantData] = React.useState([]);
    const [userType, setUserType] = React.useState('');
    const [highLevelEventInfos, setHighLevelEventInfos] = React.useState();

    // const [agentProfile, setAgentProfile] = React.useState();
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    // const authState = useAuthState();
    const themeState = useThemeState();

    // console.log("history",history);
    const loading = useState(true);
    const classes = useStyles();
    const getAgentConnections = () => {
        ApiHelper.get(
            APIURLConstants.GET_AGENT_CONNECTIONS(
                userInfo.userID,
                eventInfo.eventID
            )
        )
            .then((res) => {
                // console.log("res.data",res.data);
                if (res.data && res.data.length > 0) {
                    // console.log("userInfo",userInfo);
                    let result;
                    if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) {
                        result = res.data.filter((x) => x.moduleName != "ContentCircuit" && x.moduleName != "ActivityTracker").reduce(function (r, c) {
                            r[c.userID] = r[c.userID] || {
                                userID: c.userID,
                                userType: c.userType,
                                userRoleType: c.userRoleType,
                                firstName: c.firstName,
                                lastName: c.lastName,
                                email: c.email,
                                picUrl: c.profilePicUrl,
                                roles: c.roles,
                                isNotification: c.isNotification,
                                appNotificationSetting: c.appNotificationSetting,
                                // moduleName:c.moduleName,
                                // statusName:c.statusName
                                modules: [],
                                userTags: c.userTags,
                                isPublished: c.isPublished,
                                pcmsPlayerID: c.pcmsPlayerID
                            };
                            r[c.userID].modules.push({
                                moduleName: c.moduleName,
                                displayName: c.displayName,
                                statusName: c.statusName,
                                status: c.requestStatus,
                                noAccess: c.noAccess,
                            });

                            return r;
                        }, {});
                    } else {
                        result = res.data.filter((x) => x.isPublished === true && x.moduleName != "ContentCircuit" && x.moduleName != "ActivityTracker").reduce(function (r, c) {
                            r[c.userID] = r[c.userID] || {
                                userID: c.userID,
                                userType: c.userType,
                                userRoleType: c.userRoleType,
                                firstName: c.firstName,
                                lastName: c.lastName,
                                email: c.email,
                                picUrl: c.profilePicUrl,
                                roles: c.roles,
                                isNotification: c.isNotification,
                                appNotificationSetting: c.appNotificationSetting,
                                // moduleName:c.moduleName,
                                // statusName:c.statusName
                                modules: [],
                                userTags: c.userTags,
                                isPublished: c.isPublished,
                                pcmsPlayerID: c.pcmsPlayerID
                            };
                            r[c.userID].modules.push({
                                moduleName: c.moduleName,
                                displayName: c.displayName,
                                statusName: c.statusName,
                                status: c.requestStatus,
                                noAccess: c.noAccess,
                            });

                            return r;
                        }, {});
                    }

                    Helper.setSessionStorage(
                        'agentConnections',
                        Object.values(result)
                    );
                    loading.set(false);
                    let data = Object.values(result).reduce(
                        (r, o) => {
                            r[
                                o.userID === userInfo.userID
                                    ? 'agentProfile'
                                    : 'agentConnections'
                            ].push(o);
                            return r;
                        },
                        { agentProfile: [], agentConnections: [] }
                    );
                    // console.log("data",data);
                    var byName = data.agentConnections && data.agentConnections.slice(0);
                    byName && byName.sort(function (a, b) {
                        var x = a.firstName.toLowerCase() + a.lastName.toLowerCase();
                        var y = b.firstName.toLowerCase() + b.lastName.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                    });
                    const newData = {
                        agentProfile: data.agentProfile, agentConnections: byName
                    }
                    // console.log("byName",byName,newData);
                    setAgentData(newData);
                }else if(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)){
                    loading.set(false);
                    const newData = {
                        agentProfile: [userInfo], agentConnections: []
                    }
                    setAgentData(newData);
                }else{
                    loading.set(false);
                }
            })
            .catch((err) => {
                //... Check if user's session has expired
                if (err.response && err.response.status === 401) {
                    console.log(err);
                }
            });
    };
    // console.log('themeState',agentData, userInfo);
    const userImpersonate = (user) => {
        //Helper.setStorage('userInfo', user);
        // let getURL = APIURLConstants.SET_USER_AS(user.userID);
        if (eventInfo) {
            const path = generatePath(RouteConstants.EVENT_DETAIL, {
                eventID: eventInfo.eventID,
            });
            Helper.setStorage('impInfo', 1);
            history.push({
                pathname: path,
                state: { event: eventInfo },
            });
            if (user.userRoleType === "EventStaff" || user.userRoleType === "EventAdmin") {
                getDetails()
            }
            setAgentVisible(user);
            updateModuleState();
        }
        // ApiHelper.get()
        //     .then(() => {
        //         ApiHelper.get(APIURLConstants.GET_EVENT(eventInfo.eventID,user.userID))
        //         .then((res) => {
        //             Helper.setStorage('UserEvents', res.data);
        //             const path = generatePath(RouteConstants.EVENT_DETAIL, {
        //                 eventID: eventInfo.eventID,
        //             });
        //             setTheme(res.data);
        //             history.push({
        //                 pathname: path,
        //                 state: { event: res.data },
        //             });
        //             setAgentVisible(user);
        //             updateModuleState();
        //         })  

        //     })
        //     .catch((err) => {
        //         //... Check if user's session has expired
        //         if (err.response && err.response.status === 401) {
        //             console.log(err);
        //         }
        //     });
    };
    useEffect(() => {
        if (agentState.visible.value) {
            handleAgentEventClose();
        }
        const location = history.location;
        // debugger
        // if (location && typeof location.state !== 'undefined') {
        //     // console.log("into if");
        //     const event = location.state.event;
        //     debugger
        //     setHighLevelEventInfos(event)
        // }else{
        // console.log("into else");
        ApiHelper.get(APIURLConstants.GET_EVENT(eventInfo.eventID, userInfo.userID))
            .then((res) => {
                if (res.data) {
                    setHighLevelEventInfos(res.data);
                }

            })
        // }
        // setTimeout(() => {
        getAgentConnections();
        // }, 1000); 
    }, []);

    const handleOpen = (e, index, key, type) => {
        setParticipantData(key);
        setUserType(type);
        openDialog.set(true);
    };
    const handleClose = () => {
        openDialog.set(false);
    };
    // console.log("agentData", agentState, agentData);
    // const weatherData = Weather();



    return (
        <>
            {loading.get() ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                    }}>
                    <CircularProgress />
                </Box>
            ) : (
                <>

                    <Box
                        sx={{
                            padding: 0,
                            width: '100%',
                            backgroundColor: '#F6F8FD',
                        }}
                    >
                        <Box
                            //className={classes.paperHeaderContent}
                            sx={{
                                display: 'flex',
                                flexDirection: {
                                    xs: 'column',
                                    md: 'row',
                                },
                                width: '100%',
                                justifyContent: 'end',
                            }}
                        > <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', borderBottom: '1px solid #638CDB', boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.4)', backgroundColor: 'white' }}>
                                <Box
                                    component="img"
                                    style={{
                                        height: 100,
                                        // padding:'15px 0px 5px 7px' 
                                        marginTop: '20px',
                                        marginLeft: '10px'
                                    }}
                                    alt="logo"
                                    src={
                                        !themeState.eventEnabled.value
                                            ? Logo
                                            : themeState.eventImageUrl.value != ''
                                                ? themeState.eventImageUrl.value
                                                : DefaultEvent
                                    }
                                />
                                <Box>
                                    <Weather />
                                </Box>
                            </Box>
                        </Box>
                        {(highLevelEventInfos && highLevelEventInfos.highLevelEventInfo) ? <Box
                            //className={classes.paperHeaderContent}
                            sx={{
                                display: 'flex',
                                flexDirection: {
                                    xs: 'column',
                                    md: 'row',
                                },
                                width: '100%',
                                justifyContent: 'center',
                            }}
                        >
                            <Box sx={{ pb: 1, width: '100%' }}>
                                <Paper sx={{
                                    boxShadow: 'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
                                    borderRadius: theme.spacing(3),
                                    padding: theme.spacing(3),
                                    maxHeight: '100%',
                                    maxWidth: '100%',
                                    display: 'flex',
                                    margin: '10px 25px 25px 25px',
                                    maxWidth: '100%',
                                    boxSizing: 'border-box',
                                    overflow: 'auto',
                                    justifyContent: 'center',
                                }}>
                                    <div style={{ fontSize: '17px', lineHeight: '30px', color: '#737373', fontFamily: 'Lato', }}

                                        dangerouslySetInnerHTML={{
                                            __html: highLevelEventInfos.highLevelEventInfo,
                                        }} />
                                </Paper>
                            </Box>
                        </Box> : null}
                        <Box
                            sx={{
                                padding: 1,
                                paddingLeft: 2
                            }}>
                            <Title title="My Profile" />
                        </Box>
                        <Box>
                            {agentData &&
                                agentData.agentProfile &&
                                agentData.agentProfile.length > 0 ? (
                                agentData.agentProfile.map((data, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <ProfileSections
                                                data={data}
                                                index={index}
                                                handleOpen={handleOpen}
                                                roleType='agent'
                                                userImpersonate={userImpersonate}
                                                getStatus={getStatus}
                                            />
                                        </React.Fragment>
                                    );
                                })
                            ) : (
                                <Box>Data not found</Box>
                            )}{' '}
                            <Box
                                sx={{
                                    padding: 1,
                                    paddingLeft: 2

                                }}>
                                <Title title="My Participants" />
                            </Box>
                            {agentData &&
                                agentData.agentConnections &&
                                agentData.agentConnections.length > 0 ? (
                                agentData.agentConnections.map((data, index) => {
                                    // console.log('data', data);
                                    if ((data.userRoleType === 'EventAdmin' || data.userType === 'Admin') || data.isPublished) {
                                        return (
                                            <React.Fragment key={index}>
                                                <ProfileSections
                                                    data={data}
                                                    index={index}
                                                    handleOpen={handleOpen}
                                                    roleType='participant'
                                                    userImpersonate={userImpersonate}
                                                    getStatus={getStatus} />
                                            </React.Fragment>
                                        );
                                    }
                                })
                            ) : (
                                <Box>Data not found</Box>
                            )}
                            {openDialog.get() && (
                                <NotificationSetting
                                    open={openDialog.get()}
                                    participantData={participantData}
                                    snackBarProps={snackBarProps}
                                    setSnackBarProps={setSnackBarProps}
                                    userType={userType}
                                    handleClose={handleClose}
                                    data={agentData}
                                    getAgentConnections={getAgentConnections}
                                />
                            )}
                            {/* 
                        {dataRowItem('Draymond Green')}
                        {dataRowItem('Giannis Antetokounmpo')}
                        {dataRowItem('Stephen Curry')} */}
                            {snackBarProps.openSnack && (
                                <CustomizedSnackbars
                                    {...snackBarProps}
                                    onClose={() =>
                                        setSnackBarProps({
                                            ...snackBarProps,
                                            openSnack: false,
                                        })
                                    }></CustomizedSnackbars>
                            )}
                        </Box>
                    </Box>
                </>
            )}
        </>
    );
};

// const dataRowItem = (primary) => {
//     return <>{primary}</>;
// };
// const dataRowItem = (primary) => {
//     console.log('primar', primary);
//     const classes = useStyles();
//     return (
//         <ListItem className={classes.paperContent}>
//             <ListItemAvatar>
//                 <Avatar alt={primary} src="/broken-image.jpg" />
//             </ListItemAvatar>
//             <ListItemText
//                 className={classes.list_item_text}
//                 primary={
//     <Typography
//     sx={{
//         fontWeight: 'bold',
//         alignItems: 'center',
//         display: 'flex',
//         width: '150px',
//         minWidth: '150px',
//         border: 0,
//         borderRight: 2,
//         borderStyle: 'solid',
//         borderColor: '#a1a1a1',
//         marginRight: 1,
//     }}>
//     {primary}
// </Typography>
//                 }
//                 secondaryTypographyProps={{
//                     flex: 1,
//                     display: 'flex',
//                     alignItems: 'center',
//                 }}
//                 secondary={
//                     <Box
//                         component="span"
//                         sx={{
//                             display: 'flex',
//                             flexDirection: 'row',
//                             justifyContent: 'space-between',
//                             marginLeft: 2,
//                             width: '100%',
//                         }}>
//                         {/* {getInfoBlock(
//                             <AirTransportIcon />,
//                             'Guest Info',
//                             'Pending'
//                         )}
//                         {getInfoBlock(
//                             <AirTransportIcon />,
//                             'Hotel Info',
//                             'Approved'
//                         )}
//                         {getInfoBlock(
//                             <AirTransportIcon />,
//                             'Transport Info',
//                             ''
//                         )}
//                         {getInfoBlock(
//                             <AirTransportIcon />,
//                             'Ticket Info',
//                             'Pending'
//                         )} */}
//                         <Button variant="contained" size="small">
//                             Select
//                         </Button>
//                     </Box>
//                 }
//             />
//         </ListItem>
//     );
// };

// const getInfoBlock = (icon, title, status) => {
//     const classes = useStyles();
//     return (

//     );
// };

export default {
    routeProps: {
        path: RouteConstants.EVENT_AGENT_PROFILE,
        component: AgentProfile,
    },
    name: 'AgentProfile',
};
